
export const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export const required = value => (value ? undefined : 'Required');
export const mustBeNumber = value => (isNaN(value) ? 'The value should be a number' : '');
